import { Critica } from '../protocols';

/**
 *
 * @param type 0 - Capa, 1 - Itens, 2 - Financeiro, 3 - Guia, 4 - ICMS, 5 - Frete, 6 - Fornecedor
 * @param title
 * @param message
 * @param calculatedValue
 * @param fieldName
 * @returns
 */

export function createCritica(
  type: number,
  title: string,
  message: string,
  calculatedValue = 0,
  fieldName = '',
): Critica {
  return {
    type,
    title,
    message,
    show: true,
    calculatedValue,
    fieldName,
  };
}
